/* eslint-disable react-hooks/exhaustive-deps */
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import MaterialServices from "api/medical-materials";
import SettingServices from "api/setting";
import { TIMES, UNIT } from "constant";
import { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  table: {
    width: "100%",
    background: "#c8c8c8",
  },
  tableHeaderCell: {
    fontWeight: "bold",
  },
  hover: {
    cursor: "pointer",
  },
  center: {
    textAlign: "center",
  },
  name: {
    color: "#0e8c47",
  },
}));

const tableHeader = [
  { label: "Tên thuốc", data: "medicalMaterialName" },
  { label: "Số lượng", data: "quantityPerUnit" },
  { label: "Liều lượng", data: "description" },
  { label: "Ghi chú", data: "description" },
  { label: "", data: "" },
];

const MTable = ({ dataProps, form, setForm }) => {
  const [newData, setNewData] = useState({});
  const [medicals, setMedicals] = useState([]);
  const [data, setData] = useState(dataProps || []);
  const classes = useStyles();

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (name === "medicalMaterialName") {
      setNewData({
        ...newData,
        unit: value?.unit,
        medicalMaterialId: value?.id,
        medicalMaterialName: value?.name,
      });
    } else {
      setNewData({
        ...newData,
        [name]: value,
      });
    }
  };

  const addItem = () => {
    const newArray = [...data, newData];
    setData(newArray);
    setForm({ ...form, prescriptions: { value: newArray } });
    setNewData({});
  };

  const deleteItem = (index) => {
    const newData = data.filter((data, i) => i !== index);
    setData(newData);
    setNewData();
  };

  const fetchMedical = async () => {
    try {
      const response = await MaterialServices.getMaterials({
        type: "prescription",
      });
      setMedicals(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPrescription = async () => {
    try {
      const response = await SettingServices.getDataWithKey(form.key);
      setData(response.data.value[form.key]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setForm({ ...form, prescriptions: { value: data } });
  }, [data]);

  useEffect(() => {
    fetchMedical();
  }, []);

  useEffect(() => {
    fetchPrescription();
  }, []);
  return (
    <>
      <TableContainer
        component={Paper}
        className={classes.tableContainer}
        style={{ boxShadow: "none", padding: "0px 15px" }}
      >
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {tableHeader.map((cell) => (
                <TableCell key={cell.data} className={classes.tableHeaderCell}>
                  {cell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, i) => (
              <TableRow key={row.id}>
                <TableCell>
                  <Grid container>
                    <Typography className={classes.name}>
                      {row.medicalMaterialName}
                    </Typography>
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid container>
                    <Typography className={classes.name}>
                      {row.quantityPerUnit} {row?.unit}
                    </Typography>
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid container>
                    <Typography className={classes.name}>
                      ngày uống {row.timesAday} lần, mỗi lần {row.timesADrink}{" "}
                      viên, {row.time} ăn
                    </Typography>
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid container>
                    <Typography className={classes.name}>
                      {row.description}
                    </Typography>
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid container>
                    <Grid item>
                      <Typography>
                        <DeleteIcon
                          color="secondary"
                          onClick={deleteItem.bind(this, i)}
                          className={classes.hover}
                        />
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box className="w-full flex flex-col gap-4" my={4}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Autocomplete
                className="w-full"
                disablePortal
                options={medicals?.map((item) => item.name)}
                value={newData?.medicalMaterialName || ""}
                onInputChange={(_, e) =>
                  handleFormChange({
                    target: {
                      name: "medicalMaterialName",
                      value: medicals?.filter((item) => item.name === e)[0],
                    },
                  })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tên thuốc"
                    name="medicalMaterialName"
                  />
                )}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                label="Số lượng"
                onChange={handleFormChange}
                name="quantityPerUnit"
                value={newData?.quantityPerUnit || ""}
                className="w-full"
              />
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                className="w-full"
                disabled
                disablePortal
                options={UNIT}
                value={newData?.unit || ""}
                onInputChange={(_, e) =>
                  handleFormChange({
                    target: {
                      name: "unit",
                      value: e,
                    },
                  })
                }
                renderInput={(params) => (
                  <TextField {...params} label="Loại" name="unit" />
                )}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                label="Ngày uống mấy lần"
                onChange={handleFormChange}
                name="timesAday"
                value={newData?.timesAday || ""}
                className="w-full"
                type="number"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Lần uống mấy viên"
                onChange={handleFormChange}
                name="timesADrink"
                value={newData?.timesADrink || ""}
                className="w-full"
                type="number"
              />
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                className="w-full"
                disablePortal
                options={TIMES}
                inputValue={newData?.time || ""}
                value={newData?.time || ""}
                onInputChange={(_, e) =>
                  handleFormChange({
                    target: {
                      name: "time",
                      value: e,
                    },
                  })
                }
                renderInput={(params) => (
                  <TextField {...params} label="Trước hay sau ăn" name="time" />
                )}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Ghi chú"
                onChange={handleFormChange}
                name="description"
                value={newData?.description || ""}
                className="w-full"
              />
            </Grid>
          </Grid>
        </Box>
        <Grid container>
          <Grid item lg={4}>
            <Typography>
              <Button
                variant="contained"
                onClick={addItem}
                startIcon={<AddIcon />}
              >
                Lưu
              </Button>
            </Typography>
          </Grid>
        </Grid>
      </TableContainer>
    </>
  );
};

export default MTable;
